import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { CallbackComponent } from './callback/callback.component';
import { AuthGuard } from './services/guards/login-guard.guard';

const DETAIL_FILE_LEGACY_PREFIXES = ['file', 'salidas-fijas', 'file-hijo'];
const DETAIL_FILE_NESTED_PREFIXES = ['file', 'salidas-fijas', 'file-hijo'];
const UUID_SEGMENT_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function detailFileLegacyMatcher(
  segments: UrlSegment[]
): UrlMatchResult | null {
  if (
    segments.length === 3 &&
    segments[0].path === 'file' &&
    DETAIL_FILE_NESTED_PREFIXES.includes(segments[1].path) &&
    UUID_SEGMENT_PATTERN.test(segments[2].path)
  ) {
    return { consumed: [segments[0], segments[1]] };
  }

  if (
    segments.length === 2 &&
    DETAIL_FILE_LEGACY_PREFIXES.includes(segments[0].path) &&
    UUID_SEGMENT_PATTERN.test(segments[1].path)
  ) {
    return { consumed: [segments[0]] };
  }

  return null;
}

const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth',
    pathMatch: 'full'
  },
  { path: 'callback', component: CallbackComponent },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./main/main-routing.module').then((m) => m.MainRoutingModule)
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/auth-routing.module').then((m) => m.AuthRoutingModule)
  },
  {
    matcher: detailFileLegacyMatcher,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../pages/detail-file/detail-file.module').then(
        (m) => m.DetailFileModule
      )
  },
  {
    path: 'file',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./file/file-routing.module').then((m) => m.FileRoutingModule)
  },
  {
    path: 'programacion-aventura',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./programacion-aventura/programacion-aventura-routing.module').then(
        (m) => m.ProgramacionAventuraRoutingModule
      )
  },
  {
    path: 'programacion-personal-campo',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./programacion-aventura/programacion-personal-campo/programacion-personal-campo-routing.module').then(
        (m) => m.ProgramacionPersonalCampoRoutingModule
      )
  },
  {
    path: ':location/programacion-personal-campo',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./programacion-aventura/programacion-personal-campo/programacion-personal-campo-routing.module').then(
        (m) => m.ProgramacionPersonalCampoRoutingModule
      )
  },
  {
    path: 'incidencias',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./incidencias/incidencias-routing.module').then(
        (m) => m.IncidenciasRoutingModule
      )
  },
  {
    path: 'gestion-proveedores',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./gestion-proveedores/gestion-proveedores-routing.module').then(
        (m) => m.GestionProveedoresRoutingModule
      )
  },
  {
    path: 'orden-compra',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./orden-compra/orden-compra-routing.module').then(
        (m) => m.OrdenCompraRoutingModule
      )
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
